module.exports = __webpack_public_path__ + "static/10-e7a730f0c5521be6de6b82dab4a42887.png";